export default "__VITE_ASSET__DNIOmbLK__"